import { defineComponent as _defineComponent } from 'vue'
import {ISignalFilter, ISignalFilters} from "@/shared";
import {ref} from "vue";
import TableResponsive from "@/components/common/TableResponsive.vue";

// props
interface IProps {
	availableFilters: ISignalFilters,
}

interface IEmits {
	(
		e: "select",
		filter: ISignalFilter
	);
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterAddModal',
  props: {
    availableFilters: null
  },
  emits: ["select"],
  setup(__props: any, { expose, emit }: { emit: ({
	(
		e: "select",
		filter: ISignalFilter
	);
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	availableFilters: ISignalFilters,
};



// data
const visible = ref<boolean>(false);

// methods
function selectFilter(filter: ISignalFilter) {
	emit("select", filter);
	hide();
}

function show() {
	visible.value = true;
}

function hide() {
	visible.value = false;
}

function typeIcon(typ) {
	switch (typ) {
		case "uint64":
		case "uint32":
			return "123"
		case "float64":
		case "float32":
			return "percent"
		case "mint":
			return "coin"
		case "wallet":
			return "wallet"
		default:
			return "code"
	}
}

// emit


// expose
expose({show, hide});

return { __sfc: true,props, visible, selectFilter, show, hide, typeIcon, emit, TableResponsive }
}

})